import React, { useEffect, useState } from 'react';
import Activity from '../Activity/Activity';
import List from '../List/List';
import './ActivityList.css'

const ActivityList = () => {
    const [activitis, setActivitis] = useState([]);
    const [list, setList] = useState([]);
    useEffect(() => {
        fetch('activitydata.JSON')
            .then(res => res.json())
            .then(data => setActivitis(data))
    }, []);




    const handleAddToList = (activity) => {
        let newlist = [...list, activity];

        setList(newlist)
    }

    return (
        <div className='activityList-container'>

            <div className="activitis-container">

                {
                    activitis.map(activity => <Activity
                        key={activity.id}
                        activity={activity}
                        handleAddToList={handleAddToList}
                    ></Activity>)
                }
            </div>
            <div className="list-container">
                <List list={list}></List>

            </div>
            <div>
                <h1>FAQ</h1>
                <div className='faq-section'>
                    <h3>1. How does React work?</h3>
                    <div className='faq-table'>
                        <p>React is a declarative, efficient, and flexible JavaScript library for building user interfaces.ReactJS is an open-source, component-based front end library responsible only for the view layer of the application.

                            While building client-side apps, a team of Facebook developers realized that the DOM is slow (The Document Object Model (DOM) is an application programming interface (API) for HTML and XML documents. It defines the logical structure of documents and the way a document is accessed and manipulated.). So, to make it faster, React implements a virtual DOM that is basically a DOM tree representation in JavaScript. So when it needs to read or write to the DOM, it will use the virtual representation of it. Then the virtual DOM will try to find the most efficient way to update the browser’s DOM.
                            Unlike browser DOM elements, React elements are plain objects and are cheap to create. React DOM takes care of updating the DOM to match the React elements. The reason for this is that JavaScript is very fast and it’s worth keeping a DOM tree in it to speed up its manipulation.
                            Although React was conceived to be used in the browser, because of its design it can also be used in the server with Node.js.</p>
                    </div>
                    <p></p>
                </div>
                <div className='faq-section'>
                    <h3>1. Differences between props and state?</h3>
                    <div className='faq-table'>
                        <div>
                            <h4>Props</h4>
                            <ul>
                                <li>The Data is passed from one component to another.</li>
                                <li>It is Immutable (cannot be modified).</li>
                                <li>Props can be used with state and functional components.</li>
                                <li>Props are read-only.</li>
                            </ul>
                        </div>
                        <div>
                            <h4>State</h4>
                            <ul>
                                <li>The Data is passed within the component only.</li>
                                <li>It is Mutable ( can be modified).</li>
                                <li>State can be used only with the state components/class component (Before 16.0).</li>
                                <li>State is both read and write.</li>
                            </ul>
                        </div>
                    </div>
                    <p></p>
                </div>
                <div className='faq-section'>
                    <h3>3. what is the uses of useeffect without data load?</h3>
                    <p>It runs when the component is mounted and when it is re-rendered while a dependency of the useEffect has changed. This is powerful, but it is easy to omit dependencies and create bugs in your app.</p>
                </div>
            </div>
        </div>
    );
};

export default ActivityList;